import { render, staticRenderFns } from "./editRecordsList.vue?vue&type=template&id=9d9a296a&scoped=true&"
import script from "./editRecordsList.vue?vue&type=script&lang=js&"
export * from "./editRecordsList.vue?vue&type=script&lang=js&"
import style0 from "./editRecordsList.vue?vue&type=style&index=0&id=9d9a296a&lang=scss&scoped=true&"
import style1 from "./editRecordsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9a296a",
  null
  
)

export default component.exports